import { withdrawalMethodQueryKeys as e } from "./useWithdrawalMethodQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { paymentsApi as n } from "@maat/api-payments";
//#region src/withdrawal-methods/useWithdrawalMethodsQuery.ts
var r = (r) => t({
	queryKey: e.forWorkspace(r),
	queryFn: () => n.listWithdrawalMethods(r),
	enabled: !!r
});
//#endregion
export { r as useWithdrawalMethodsQuery };
